export default ["/admin"];
